(function () {
  "use strict";

  // One customer token per browser session, shared by every slot.
  //
  // Before this (v0.11.1 and earlier) rewards, wishlist, promos and chat each
  // minted their own token on every page view — three /auth calls per view
  // against a 10-per-IP-per-5-minute limit, so a customer browsing normally
  // (or an office behind one IP) hit 429 and the widgets went quiet
  // (SECURITY_BACKLOG #11). The token lives 60 minutes; cache it for 55 in
  // sessionStorage keyed on the customer id, and collapse parallel callers on
  // one page view into a single mint.
  //
  // Load this BEFORE the slots. Every slot falls back to its own mint when
  // QB.token is missing, so an old theme still works.

  var VERSION = "0.1.0";
  var TTL_MS = 55 * 60 * 1000;
  var inflight = null;

  function key(customer) {
    return "qb_token_" + String(customer.id);
  }

  function read(customer) {
    try {
      var raw = sessionStorage.getItem(key(customer));
      if (!raw) return null;
      var hit = JSON.parse(raw);
      if (!hit || !hit.token || !(hit.exp > Date.now() + 60000)) return null;
      return hit.token;
    } catch (e) {
      return null;
    }
  }

  function write(customer, token) {
    try {
      sessionStorage.setItem(key(customer), JSON.stringify({ token: token, exp: Date.now() + TTL_MS }));
    } catch (e) {
      /* storage unavailable — the in-memory promise still dedupes this page view */
    }
  }

  async function mint(customer) {
    var url = window.QB && window.QB.worker && window.QB.worker.url;
    if (!url) throw new Error("no_worker");
    var res = await fetch(url + "/auth", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "token", customerId: customer.id, email: customer.email }),
    });
    var data = await res.json().catch(function () {
      return {};
    });
    if (!res.ok || !data.token) throw new Error(data.error || "auth_failed");
    write(customer, data.token);
    return data.token;
  }

  window.QB = window.QB || {};
  window.QB.authVersion = VERSION;

  /** Resolves to the customer's token, or null for a guest. Rejects on a failed mint. */
  window.QB.token = function (customer) {
    if (!customer || !customer.loggedIn || !customer.id || !customer.email) return Promise.resolve(null);
    var cached = read(customer);
    if (cached) return Promise.resolve(cached);
    if (!inflight) {
      inflight = mint(customer).finally(function () {
        inflight = null;
      });
    }
    return inflight;
  };

  /** Drop the cached token (after a 401) so the next call mints a fresh one. */
  window.QB.tokenClear = function (customer) {
    try {
      if (customer && customer.id) sessionStorage.removeItem(key(customer));
    } catch (e) {
      /* ignore */
    }
  };
})();
